import styled from 'styled-components/macro';

export const Container = styled.div`
  height: 2rem;
  border-top: solid 1px var(--line-color);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.span`
  text-align: center;
`;
